/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Builders_TitleInputs */

const en_directory_builders_title = /** @type {(inputs: Directory_Builders_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meet the people behind the directory`)
};

const zh_directory_builders_title = /** @type {(inputs: Directory_Builders_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`认识目录背后的创作者`)
};

/**
* | output |
* | --- |
* | "Meet the people behind the directory" |
*
* @param {Directory_Builders_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_builders_title = /** @type {((inputs?: Directory_Builders_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Builders_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_builders_title(inputs)
	return zh_directory_builders_title(inputs)
});
export { directory_builders_title as "directory.builders.title" }